import type {
  VerificationProfileSummary,
} from '@nightshift/ui-types';

import { canWriteSettings } from './privilege.ts';

export const PROFILE_CAPTURE_SUGGESTIONS = ['capture', 'launch'] as const;

export const PROFILE_THRESHOLD_METRICS = ['fps', 'fps_avg', 'fps_p95', 'load_ms', 'memory_mb'] as const;

export function canWriteProfiles(user: { role: string } | null): boolean {
  return canWriteSettings(user);
}

export function contractWriteBody(row: {
  ci: 'required' | 'skip' | null;
  buildRequired: boolean | null;
  unitTestsRequired: boolean | null;
  humanReviewRequired: boolean | null;
  reviewerNames: string[];
  captureNames: string[];
  performanceThreshold: { metric: string; comparison: string; value: number } | null;
}): {
  ci: 'required' | 'skip';
  buildRequired: boolean;
  unitTestsRequired: boolean;
  humanReviewRequired: boolean;
  reviewerNames: string[];
  captureNames: string[];
  performanceThreshold: { metric: string; comparison: string; value: number } | null;
} {
  return {
    ci: row.ci === 'skip' ? 'skip' : 'required',
    buildRequired: row.buildRequired !== false,
    unitTestsRequired: row.unitTestsRequired !== false,
    humanReviewRequired: row.humanReviewRequired !== false,
    reviewerNames: [...row.reviewerNames],
    captureNames: [...row.captureNames],
    performanceThreshold: row.performanceThreshold
      ? {
          metric: row.performanceThreshold.metric,
          comparison: row.performanceThreshold.comparison,
          value: row.performanceThreshold.value,
        }
      : null,
  };
}

export function draftFromSummary(row: VerificationProfileSummary) {
  return contractWriteBody(row);
}

export function toggleNamed(list: readonly string[], name: string): string[] {
  if (list.includes(name)) return list.filter((entry) => entry !== name);
  return [...list, name];
}
